module.exports = __webpack_public_path__ + "img/9788958284567.4d900849.jpg";